// client/src/index.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'react-datepicker/dist/react-datepicker.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Suppress console logs in production
if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.info = () => {};
  console.debug = () => {};
  console.warn = () => {};
  // Keep console.error for critical issues
}

const root = ReactDOM.createRoot(
 document.getElementById('root') as HTMLElement
);

root.render(
 <React.StrictMode>
   <App />
 </React.StrictMode>
);

reportWebVitals();